import { media } from "sprout-ui-theme";
import { css } from "styled-components";
// eslint-disable-next-line import/prefer-default-export
export const layoutPadding = css`
  padding-left: 16px;
  padding-right: 16px;

  ${media.up("medium", "pointer")} {
    padding-left: 128px;
    padding-right: 128px;
  }
`;
